module.exports = __webpack_public_path__ + "static/043-d3d3bc08937125f2f538de03d0a7a3dc.jpg";